import React, { Component } from 'react';
import { connect } from 'react-redux';
import Header from './Header';
import Footer from './Footer';


class Layout extends Component {
 constructor(props) {
        super(props);

    }

  render() {
   
  	 


    return (
	<div>
      <Header languagedata={this.props.languagedata}/>
		{this.props.children}
	  <Footer languagedata={this.props.languagedata}/>
	 </div> 
    );
  }
}

export default Layout;



// WEBPACK FOOTER //
// ./src/layout/Layout.js